var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 752 752"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m578.86 258.54-85.391-85.391c-5.785-5.785-15.141-5.785-20.926 0l-284.59 284.59a14.776 14.776 0 0 0-4.336 10.461v85.391c0 8.184 6.617 14.801 14.801 14.801h85.391c3.938 0 7.695-1.555 10.465-4.336l284.59-284.59c5.785-5.785 5.785-15.156-.004-20.926zm-301.2 280.25h-64.453v-64.453l216.29-216.3 64.453 64.453zm237.23-237.22-64.453-64.453 32.574-32.574 64.453 64.453z"
  })));
};
export default SvgPencil;